import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

const logger = Logger.getLogger('currencyUtils');

/**
 * @param {String} locale - '<country>' or '<country>-<language>'
 * @param {String} currencyCode
 * @return {Object} supportedCurrency object
 */
function getSymbolForLocale(locale, currencyCode) {
    try {
        const currencyFormatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
            useGrouping: false,
            maximumSignificantDigits: 1,
        });

        return currencyFormatter.format(1)
            .replace(/\s/g, '')
            .replace(/[0-9]+/i, '') // Latin Numberals
            // The following Number Systems are complex and these regex's are not perfect
            .replace(/[۰-۹]+/i, '') // Persian Numerals
            .replace(/[〇-九]+/i, '') // Kanji Numerals
            .replace(/[๐-๑๐]+/i, ''); // Thai Numerals
    } catch (ex) {
        const domainUserInfo = appSettings.env.isClient
            ? SnowplowService.getDomainUserInfo()
            : {};

        logger.error('getSymbolForLocale', ex, {
            snowplowIds: {
                networkUserId: SnowplowService.getNetworkUserId(),
                ...domainUserInfo,
            },
        });
        return '';
    }
}

function getCurrencyName(currency, locale) {
    const result = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'name',
        minimumFractionDigits: 0,
    }).format(1);

    return result.substring(2);
}

export {
    getCurrencyName,
    getSymbolForLocale,
};
